
import { Component, OnInit } from '@angular/core';
import { EmployeeService } from '../services/employee.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, } from '@angular/forms';
@Component({
  selector: 'app-business',
  templateUrl: './business.component.html',
  styleUrls: ['./business.component.scss']
})
export class BusinessComponent implements OnInit {

  signupForm: FormGroup;
  private istermschecked: boolean;
  private formSubmitAttempt: boolean;
  private countryCode: string;
  constructor(private _employeeService: EmployeeService, private router: Router, private fb: FormBuilder, ) {

    this.signupForm = fb.group({
      name: ['', Validators.compose([Validators.required, Validators.maxLength(15), Validators.minLength(1)])],

      email: ['', [
        //Validators.required,
        Validators.pattern("[^ @]*@[^ @]*")
      ]],
      mobile: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("[0-9]+")]],

    })


  }

  ngOnInit() {
    const $ = window["$"];
    $('.menu-btn').on('click', function () {
      let elem = $(this),
        item = $('.menu__item'),
        active = 'is-active',
        play = 'menu__item--play';

      if (elem.hasClass(active)) {
        elem.removeClass(active);
        $(item.get().reverse()).each(function (i) {
          let row = $(this);
          setTimeout(function () {
            row.removeClass(play);
          }, 50 * i);
        });
      }

      else {
        elem.addClass(active);
        item.each(function (i) {
          let row = $(this);
          setTimeout(function () {
            row.addClass(play);
          }, 50 * i);
        });
      }

    });
    $('#joinNow').click(function () {
      $('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top
      }, 700);
      return false;
    });
  }

  registerEmployee(employeeForm: FormGroup) {
    this.formSubmitAttempt = true;
    this.countryCode = (this.countryCode == null || this.countryCode == '') ? "254" : this.countryCode;
    if (employeeForm.invalid) {
      return;
    }
    else {
      if (this.istermschecked) {
        employeeForm.value.usertype = 2;
        employeeForm.value.mobile = this.countryCode + employeeForm.value.mobile;
        this._employeeService.saveWebUser(employeeForm.value).subscribe(
          data => {
            if (data.returnCode == 0) {
              alert("link for download SASA-Doctor app has been sent to your email ")
              this.formSubmitAttempt = false;
              this.istermschecked = false
              employeeForm.reset();
            }
            else {
              alert(data.returnMsg)

            }
          },
          error => {
            // this.alertService.error(error);
            // this.loading = false;         
            alert(error)
            console.log(error)
          });
      }
      else {
        alert("Verify Terms And Conditions")
        return;
      }

    }




  }

  conditionchecked(e) {
    if (e.target.checked) {
      this.istermschecked = true;
    }
    else {
      this.istermschecked = false;
    }
  }

  telInputObject(obj) {
    console.log(obj);
    obj.intlTelInput('setCountry', 'ke');
  }

  onCountryChange(obj) {
    this.countryCode = obj.dialCode
    console.log(obj);
  }

  getNumber(obj) {
    console.log(obj);
  }

}



// WEBPACK FOOTER //
// ./src/app/business/business.component.ts